import { pipe } from 'ramda';

/**
 * @type {any}
 */
const DEFAULT_URL = {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    password: '',
    pathname: '',
    port: '',
    protocol: '',
    search: '',
    username: '',
};

/**
 * @param {string} url
 *
 * @return {any}
 */
const legacyUrl = (url) => {
    const a = document.createElement('a');
    a.href = url;
    return {
        hash: a.hash,
        host: a.host,
        hostname: a.hostname,
        href: a.href,
        origin: a.origin,
        password: a.password,
        pathname: a.pathname,
        port: a.port,
        protocol: a.protocol,
        search: a.search,
        username: a.username,
    };
};

const urlObjectToJs = (urlObject: URL) => ({
    hash: urlObject.hash,
    host: urlObject.host,
    hostname: urlObject.hostname,
    href: urlObject.href,
    origin: urlObject.origin,
    password: urlObject.password,
    pathname: urlObject.pathname,
    port: urlObject.port,
    protocol: urlObject.protocol,
    search: urlObject.search,
    username: urlObject.username,
});

export const parseUrl = (url?: string) => {
    try {
        const parser =
            typeof window.URL === 'function' ? (str) => urlObjectToJs(new URL(str)) : legacyUrl;
        return url ? parser(url) : DEFAULT_URL;
    } catch (err) {
        return DEFAULT_URL;
    }
};

export const stripPath = pipe(parseUrl, ({ protocol, host }) => `${protocol}//${host}`);
